import { Editor } from '@tiptap/react';
import { Space } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { ReferenceRichTextButton } from '../../../../../inputs/rich-text-advanced/menu-bar/ReferenceRichTextButton';
import { IReference } from '../../../references/IReference';
import { ComputeMathFunctionRichTextButton } from './ComputeMathFunctionRichTextButton';

// TODO Centralizzare
export const StyledSpace = styled(Space)`
  position: relative;
  z-index: 2;
`;

export interface IComputeExpressionMenuBarProps {
  editor: Editor | null;
  references: IReference[];
  noFunctions?: boolean;
}

export function ComputeExpressionMenuBar(
  props: IComputeExpressionMenuBarProps,
) {
  const { editor, references, noFunctions } = props;

  if (!editor) return null;

  return (
    <StyledSpace wrap size={2}>
      <ReferenceRichTextButton editor={editor} references={references} />
      {!noFunctions && <ComputeMathFunctionRichTextButton editor={editor} />}
    </StyledSpace>
  );
}
